import styled, { css } from 'styled-components'

import { theme } from '../../../theme'
import { IconGenerator } from '../IconGenerator'

import type { Size, StyledSwitchProps } from './types'

export const RadioWrapper = styled.div`
  width: 100%;
  display: block;
`

const smallStyles = css`
  height: 33px;
  line-height: 33px;
`

export const Indicator = styled.div<{ size?: Size }>`
  position: absolute;
  height: 46px;
  width: 50%;
  border-radius: 6px;
  top: 0;
  transition:
    transform 300ms cubic-bezier(0.02, 0.94, 0.09, 0.97),
    background 300ms cubic-bezier(0.17, 0.67, 0.14, 1.03);
  background: ${theme.colors.sapphireDark};
  ${({ size }) => (size === 'small' ? smallStyles : undefined)}
`

export const OptionLabel = styled.label<{
  size?: Size
  shareWidth: boolean
}>`
  position: relative;
  font-family: ${theme.fonts.mainFont};
  font-weight: normal;
  height: 46px;
  line-height: 46px;
  margin-bottom: 0;
  border-radius: 6px;
  transition: background 300ms ease-in-out;
  cursor: pointer;
  width: ${({ shareWidth }) => shareWidth && '50%'};
  text-align: center;
  ${({ size }) => (size === 'small' ? smallStyles : undefined)}
`

export const Input = styled.input`
  visibility: hidden;
  position: absolute;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  width: 1px;
`

export const Switch = styled.div<StyledSwitchProps>`
  background: ${theme.colors.white};
  border: 1px solid
    ${({ theme, $darkBorder }) =>
      $darkBorder ? theme.colors.crystalBay : theme.colors.white};
  border-radius: 8px;
  position: relative;

  display: flex;
  flex-direction: row;

  ${({ $isBulletDesign }) =>
    $isBulletDesign &&
    css`
      border: 1px solid ${theme.colors.cautiousBlue};
      max-height: 48px;
      &::after {
        content: ' ';
        width: 1px;
        height: 46px;
        background-color: ${theme.colors.cautiousBlue};
        display: block;
        position: absolute;
        top: 0px;
        left: 50%;
      }
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: ${theme.colors.catskillWhite};
      border-color: ${theme.colors.crystalBay};
      ${OptionLabel} {
        cursor: inherit;
      }
    `}

  ${Input} {
    & + ${OptionLabel} {
      color: ${({ theme, $disabled }) =>
        $disabled ? theme.colors.slateGray : theme.colors.sapphireDark};
    }

    ${({ $isBulletDesign }) =>
      !$isBulletDesign &&
      css`
        &:checked + ${OptionLabel} {
          color: ${theme.colors.white};
          background: ${theme.colors.sapphireDark};
          box-shadow: none;
        }
        &:first-of-type:checked ~ ${Indicator} {
          transform: translate3d(0, 0, 0);
        }

        &:last-of-type:checked ~ ${Indicator} {
          transform: translate3d(100%, 0, 0);
        }
      `}
  }
`

export const BulletWrapper = styled.div<{ isChecked?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isChecked }) =>
    isChecked &&
    css`
      font-weight: 500;
    `}
`

export const Bullet = styled(IconGenerator)<{ isChecked?: boolean }>`
  color: ${({ theme, isChecked }) =>
    isChecked ? theme.colors.sapphireDark : theme.colors.cautiousBlue};
  margin-right: 10px;
`
